export default __webpack_public_path__ + "static/20-367e1ba55bd6cf0fd7eff3491b5d1f36.webp";